import 'chart.js'
import { ResponsivePie } from 'nivo'
import React from 'react';

export default class DashboardPieCharts extends React.Component<
    { [label: string]: any }, { [label: string]: any }> {
    constructor(props) {
        super(props)
        this.state = {
            chart1Data: [],
            chart2Data: []
        }
    }

    public componentDidMount() {
        this.setState({
            chart1Data: [
                {
                    "id": "Capacity Remaining",
                    "label": "Capacity Remaining",
                    "value": Number(this.props.capacity) - Number(this.props.totalPublic) - Number(this.props.totalPrivate),
                    "color": "hsl(22, 70%, 50%)"
                },
                {
                    "id": 'Tickets Sold',
                    "label": 'Tickets Sold',
                    "value": Number(this.props.totalPublic) + Number(this.props.totalPrivate),
                    "color": "hsl(230, 70%, 50%)"
                },
            ],
            chart2Data: [
                {
                    "id": 'General Tickets',
                    "label": 'General Tickets',
                    "value": Number(this.props.totalPublic),
                    "color": "hsl(22, 70%, 50%)"
                },
                {
                    "id": 'Promoter Tickets',
                    "label": 'Promoter Tickets',
                    "value": Number(this.props.totalPrivate),
                    "color": "hsl(230, 70%, 50%)"
                }
            ]
        })
    }

    public render() {

        if (this.state.loading) {
            return null
        }

        return <div>
            <div className="card">
                <p />
                <div className='big-split-1300' style={{ width: '100%', height: '200px' }}>
                    <div style={{ float: 'left', width: '50%', zIndex: 'auto', height: '200px' }}>
                        <ResponsivePie
                            data={this.state.chart1Data}
                            margin={{ top: 30, right: 120, bottom: 30, left: 120 }}
                            padAngle={1.2}
                            colors="pastel1"
                            cornerRadius={3}
                            borderWidth={0}
                            radialLabelsSkipAngle={10}
                            radialLabelsTextXOffset={6}
                            radialLabelsTextColor="#333333"
                            radialLabelsLinkOffset={0}
                            radialLabelsLinkDiagonalLength={0}
                            radialLabelsLinkHorizontalLength={24}
                            radialLabelsLinkStrokeWidth={1}
                            slicesLabelsSkipAngle={10}
                            slicesLabelsTextColor="#333333"
                            animate={true}
                            motionStiffness={90}
                            motionDamping={15}
                            legends={[
                                {
                                    anchor: 'bottom',
                                    direction: 'row',
                                    translateY: 56,
                                    itemWidth: 100,
                                    itemHeight: 18,
                                    itemTextColor: '#999',
                                    symbolSize: 18,
                                    symbolShape: 'circle',
                                    effects: [
                                        {
                                            on: 'hover',
                                            style: {
                                                itemTextColor: '#000'
                                            }
                                        }
                                    ]
                                }
                            ]}
                        />
                    </div>
                    <div style={{ float: 'right', width: '50%', zIndex: 'auto', height: '200px' }}>
                        <ResponsivePie
                            data={this.state.chart2Data}
                            margin={{ top: 30, right: 120, bottom: 30, left: 120 }}
                            padAngle={1.2}
                            cornerRadius={3}
                            borderWidth={0}
                            colors="pastel2"
                            radialLabelsSkipAngle={10}
                            radialLabelsTextXOffset={6}
                            radialLabelsTextColor="#333333"
                            radialLabelsLinkOffset={0}
                            radialLabelsLinkDiagonalLength={0}
                            radialLabelsLinkHorizontalLength={24}
                            radialLabelsLinkStrokeWidth={1}
                            slicesLabelsSkipAngle={10}
                            slicesLabelsTextColor="#333333"
                            animate={true}
                            motionStiffness={90}
                            motionDamping={15}
                            legends={[
                                {
                                    anchor: 'bottom',
                                    direction: 'row',
                                    translateY: 56,
                                    itemWidth: 100,
                                    itemHeight: 18,
                                    itemTextColor: '#999',
                                    symbolSize: 18,
                                    symbolShape: 'circle',
                                    effects: [
                                        {
                                            on: 'hover',
                                            style: {
                                                itemTextColor: '#000'
                                            }
                                        }
                                    ]
                                }
                            ]}
                        />
                    </div>
                </div>

                <div className='small-split-1300' style={{ height: '400px' }}>
                    <div style={{ zIndex: 'auto', height: '200px' }}>
                        <ResponsivePie
                            data={this.state.chart1Data}
                            margin={{ top: 30, right: 120, bottom: 30, left: 120 }}
                            padAngle={1.2}
                            cornerRadius={3}
                            borderWidth={0}
                            colors="pastel1"
                            radialLabelsSkipAngle={10}
                            radialLabelsTextXOffset={6}
                            radialLabelsTextColor="#333333"
                            radialLabelsLinkOffset={0}
                            radialLabelsLinkDiagonalLength={0}
                            radialLabelsLinkHorizontalLength={24}
                            radialLabelsLinkStrokeWidth={1}
                            slicesLabelsSkipAngle={10}
                            slicesLabelsTextColor="#333333"
                            animate={true}
                            motionStiffness={90}
                            motionDamping={15}
                            legends={[
                                {
                                    anchor: 'bottom',
                                    direction: 'row',
                                    translateY: 56,
                                    itemWidth: 100,
                                    itemHeight: 18,
                                    itemTextColor: '#999',
                                    symbolSize: 18,
                                    symbolShape: 'circle',
                                    effects: [
                                        {
                                            on: 'hover',
                                            style: {
                                                itemTextColor: '#000'
                                            }
                                        }
                                    ]
                                }
                            ]}
                        />
                    </div>
                    <p />
                    <div style={{ zIndex: 'auto', height: '200px' }}>
                        <ResponsivePie
                            data={this.state.chart2Data}
                            margin={{ top: 30, right: 120, bottom: 30, left: 120 }}
                            padAngle={1.2}
                            cornerRadius={3}
                            borderWidth={0}
                            colors="pastel2"
                            radialLabelsSkipAngle={10}
                            radialLabelsTextXOffset={6}
                            radialLabelsTextColor="#333333"
                            radialLabelsLinkOffset={0}
                            radialLabelsLinkDiagonalLength={0}
                            radialLabelsLinkHorizontalLength={24}
                            radialLabelsLinkStrokeWidth={1}
                            slicesLabelsSkipAngle={10}
                            slicesLabelsTextColor="#333333"
                            animate={true}
                            motionStiffness={90}
                            motionDamping={15}
                            legends={[
                                {
                                    anchor: 'bottom',
                                    direction: 'row',
                                    translateY: 56,
                                    itemWidth: 100,
                                    itemHeight: 18,
                                    itemTextColor: '#999',
                                    symbolSize: 18,
                                    symbolShape: 'circle',
                                    effects: [
                                        {
                                            on: 'hover',
                                            style: {
                                                itemTextColor: '#000'
                                            }
                                        }
                                    ]
                                }
                            ]}
                        />
                    </div>
                </div>
                <p />
            </div>
            <p><br /></p>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/manage/events/detail/DashboardPieCharts.tsx